<div class="notification" [ngClass]="type()">
  <div class="icon">
    @switch (type()) { @case ('success') {
    <i class="bi bi-check-circle-fill"></i>
    } @case ('warning') {
    <i class="bi bi-exclamation-triangle-fill"></i>
    } @case ('error') {
    <i class="bi bi-x-circle-fill"></i>
    } }
  </div>

  <div class="text">
    <p class="title">{{ title() }}</p>
    <p class="message">{{ message() }}</p>
  </div>
</div>
